import { useContext, useEffect, useState, useRef, useLayoutEffect } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _div_ from "@Elementos/Div";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _opt_ from "@Elementos/Opciones";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import BloqueTabla from "@ComponentesCuerpo/BloqueTabla/BloqueTabla";

import "./ListaBloques.css";

function ListaBloques(props) {
  const { estilos, tipo, name, texto} = props.param;
  const { esComputadora, screenWidth, innerWidth } = useContext(Contexto);
  
  const ref = useRef(null)
  const [componentes, _] = useState({
    input: _ipt_.Input6,
    div: _div_.Div,
    btn: _btn_.Boton,
    bloqueTabla: BloqueTabla,
  });
  
  const [estilosLista, setEstilosLista] = useState ({})

  useLayoutEffect(() => {
    if (!ref.current) return;
    
    const anchoVentana = innerWidth;
    const anchoComputador = screenWidth;
    const anchoComponente = ref.current.getBoundingClientRect().width;

    const porcentajeComponente = anchoComponente / anchoVentana;
    console.log(estilos)
    const anchoColumna = (anchoComputador * porcentajeComponente) / (estilos.columnas+1);
    setEstilosLista({
      propiedades: estilos,
      minimo: anchoColumna * 0.5 + "px",
      maximo: anchoColumna * 1.2 + "px",
      normal: anchoColumna + "px",
    })
  }, [innerWidth, screenWidth]);

  return (
    <>
    <div className="ListaBloques" ref={ref} style={_f_.estilosObjetoVariablesCSS(estilosLista) }>
      {texto && texto.map((e) => {
        const Elemento = componentes[tipo];
        let estilosTabla = e.estilos
        let elementosTablaCabecera = estilosTabla.cabecera.map(({ name, texto }) => ({name, texto}));
        let elementosBloque = []
        return e.elementos.map((eb) => {
          if (Array.isArray(eb)){
            return eb.map((bloque) => {
              let estilosBloque = {titulo: bloque.categoria}
              let elementosTablaRegistros = bloque.elementos
              let elementosTabla = {cabecera: elementosTablaCabecera, registros: elementosTablaRegistros}
              let elementoTablaBloque = {texto: elementosTabla, tipo : "tabla", name:"tabla"+bloque.id, estilos:estilosTabla}
              elementosBloque= [elementoTablaBloque, ...e.elementos.filter(item => item !== eb)]
              console.log(elementosBloque)
              return (
                <Elemento param = {{elementos:elementosBloque, estilos:estilosBloque}}
                />)
              })
          }
          else if (!eb.tipo){

            let estilosBloque = {titulo: eb.categoria}
            let elementosTablaRegistros = eb.elementos
            let elementosTabla = {cabecera: elementosTablaCabecera, registros: elementosTablaRegistros}
            let elementoTablaBloque = {texto: elementosTabla, tipo : "tabla", name:"tabla"+eb.id, estilos:estilosTabla}
            elementosBloque= [elementoTablaBloque, ...e.elementos.filter(item => item !== eb)]
            console.log(elementosBloque)
            return (
              <Elemento param = {{elementos:elementosBloque, estilos:estilosBloque}}
              />)
          }
        })
      })}
    </div>
    </>
  )
}
export default ListaBloques;